import { render } from "./BannerHalf.vue?vue&type=template&id=409e3c06&scoped=true"
import script from "./BannerHalf.vue?vue&type=script&lang=js"
export * from "./BannerHalf.vue?vue&type=script&lang=js"

import "./BannerHalf.vue?vue&type=style&index=0&id=409e3c06&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409e3c06"]])

export default __exports__